import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp, FaBuilding } from 'react-icons/fa';

// A collapsible section wrapping one franchise's items — used on admin pages that need
// each franchise's orders/returns/pickups shown in its own separate block, never mixed
// together in one flat list.
const FranchiseGroupSection = ({ group, itemLabel = 'items', children }) => {
    const [expanded, setExpanded] = useState(true);
    const franchise = group.franchise;

    return (
        <div className="mb-6 bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div
                onClick={() => setExpanded(prev => !prev)}
                className="p-4 flex items-center justify-between cursor-pointer hover:bg-gray-50 transition-colors"
            >
                <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${franchise ? 'bg-emerald-100 text-emerald-600' : 'bg-gray-100 text-gray-400'}`}>
                        <FaBuilding />
                    </div>
                    <div>
                        <div className="flex items-center gap-2 flex-wrap">
                            <h3 className="text-base font-bold text-gray-800">{group.label}</h3>
                            {franchise && (
                                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase ${franchise.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                                    {franchise.status}
                                </span>
                            )}
                        </div>
                        {franchise?.owner?.name && (
                            <p className="text-[11px] text-gray-400">Owner: {franchise.owner.name}</p>
                        )}
                    </div>
                </div>
                <div className="flex items-center gap-4">
                    <span className="text-xs font-bold text-gray-500 whitespace-nowrap">{group.items.length} {itemLabel}</span>
                    {expanded ? <FaChevronUp className="text-gray-400" /> : <FaChevronDown className="text-gray-400" />}
                </div>
            </div>
            {expanded && (
                <div className="border-t border-gray-100 bg-gray-50/50 p-4 space-y-4">
                    {children}
                </div>
            )}
        </div>
    );
};

export default FranchiseGroupSection;
